module.exports = __webpack_public_path__ + "img/logoEng.9e4553bc.png";